import type { EmojiItem } from './types';

export const DEFAULT_EMOJIS: EmojiItem[] = [
	{
		emoji: '😀',
		name: 'grinning',
		shortcodes: ['grinning', 'grinning_face'],
		tags: ['face', 'grin'],
		group: 'smileys & emotion',
		emoticons: [],
		version: 1,
		fallbackImage:
			'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f600.png',
	},
	{
		emoji: '😃',
		name: 'smiley',
		shortcodes: ['grinning_face_with_big_eyes', 'smiley'],
		tags: ['face', 'mouth', 'open', 'smile'],
		group: 'smileys & emotion',
		emoticons: [],
		version: 0.6,
		fallbackImage:
			'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f603.png',
	},
];

export const CUSTOM_EMOJIS: EmojiItem[] = [
	{
		name: 'atom',
		shortcodes: ['atom'],
		tags: [],
		group: 'GitHub',
		fallbackImage:
			'https://github.githubassets.com/images/icons/emoji/atom.png',
	},
	{
		name: 'basecamp',
		shortcodes: ['basecamp'],
		tags: [],
		group: 'GitHub',
		fallbackImage:
			'https://github.githubassets.com/images/icons/emoji/basecamp.png',
	},
	{
		name: 'basecampy',
		shortcodes: ['basecampy'],
		tags: [],
		group: 'GitHub',
		fallbackImage:
			'https://github.githubassets.com/images/icons/emoji/basecampy.png',
	},
	{
		name: 'bowtie',
		shortcodes: ['bowtie'],
		tags: [],
		group: 'GitHub',
		fallbackImage:
			'https://github.githubassets.com/images/icons/emoji/bowtie.png',
	},
	{
		name: 'electron',
		shortcodes: ['electron'],
		tags: [],
		group: 'GitHub',
		fallbackImage:
			'https://github.githubassets.com/images/icons/emoji/electron.png',
	},
	{
		name: 'feelsgood',
		shortcodes: ['feelsgood'],
		tags: [],
		group: 'GitHub',
		fallbackImage:
			'https://github.githubassets.com/images/icons/emoji/feelsgood.png',
	},
	{
		name: 'finnadie',
		shortcodes: ['finnadie'],
		tags: [],
		group: 'GitHub',
		fallbackImage:
			'https://github.githubassets.com/images/icons/emoji/finnadie.png',
	},
	{
		name: 'goberserk',
		shortcodes: ['goberserk'],
		tags: [],
		group: 'GitHub',
		fallbackImage:
			'https://github.githubassets.com/images/icons/emoji/goberserk.png',
	},
	{
		name: 'godmode',
		shortcodes: ['godmode'],
		tags: [],
		group: 'GitHub',
		fallbackImage:
			'https://github.githubassets.com/images/icons/emoji/godmode.png',
	},
	{
		name: 'hurtrealbad',
		shortcodes: ['hurtrealbad'],
		tags: [],
		group: 'GitHub',
		fallbackImage:
			'https://github.githubassets.com/images/icons/emoji/hurtrealbad.png',
	},
	{
		name: 'neckbeard',
		shortcodes: ['neckbeard'],
		tags: [],
		group: 'GitHub',
		fallbackImage:
			'https://github.githubassets.com/images/icons/emoji/neckbeard.png',
	},
	{
		name: 'octocat',
		shortcodes: ['octocat'],
		tags: [],
		group: 'GitHub',
		fallbackImage:
			'https://github.githubassets.com/images/icons/emoji/octocat.png',
	},
	{
		name: 'rage1',
		shortcodes: ['rage1'],
		tags: [],
		group: 'GitHub',
		fallbackImage:
			'https://github.githubassets.com/images/icons/emoji/rage1.png',
	},
	{
		name: 'rage2',
		shortcodes: ['rage2'],
		tags: [],
		group: 'GitHub',
		fallbackImage:
			'https://github.githubassets.com/images/icons/emoji/rage2.png',
	},
	{
		name: 'rage3',
		shortcodes: ['rage3'],
		tags: [],
		group: 'GitHub',
		fallbackImage:
			'https://github.githubassets.com/images/icons/emoji/rage3.png',
	},
	{
		name: 'rage4',
		shortcodes: ['rage4'],
		tags: [],
		group: 'GitHub',
		fallbackImage:
			'https://github.githubassets.com/images/icons/emoji/rage4.png',
	},
	{
		name: 'shipit',
		shortcodes: ['shipit'],
		tags: [],
		group: 'GitHub',
		fallbackImage:
			'https://github.githubassets.com/images/icons/emoji/shipit.png',
	},
	{
		name: 'suspect',
		shortcodes: ['suspect'],
		tags: [],
		group: 'GitHub',
		fallbackImage:
			'https://github.githubassets.com/images/icons/emoji/suspect.png',
	},
	{
		name: 'trollface',
		shortcodes: ['trollface'],
		tags: [],
		group: 'GitHub',
		fallbackImage:
			'https://github.githubassets.com/images/icons/emoji/trollface.png',
	},
];

export const ALL_EMOJIS: EmojiItem[] = [...DEFAULT_EMOJIS, ...CUSTOM_EMOJIS];
